<span class="flex items-center gap-1">
  {{ label() }}
  @if (isRequired()) {
    <span class="text-text-error-primary">*</span>
  }
  @if (mode() === 'grid' && hint()) {
    <tui-icon
      class="shrink-0 ml-auto text-base text-text-placeholder"
      icon="@tui.circle-help"
      tuiHintDirection="end"
      [tuiHint]="hint()!" />
  }
</span>
@if (mode() === 'form' && hint()) {
  <span class="mt-1 block text-sm font-normal text-text-quaternary">{{ hint() }}</span>
}
